import { moduleRoutes } from "@/modules";
import sharedRoutes from "@/shared/router";

export const routes = [...moduleRoutes, ...sharedRoutes];
